<template>
  <!-----------------MAIN CONTAINER----------------------------------------------->
  <v-container>
    <!-----------------SEARCH BAR------------------------------------------------->
    <v-card-title v-if="!failed">
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
        clearable
      ></v-text-field>
    </v-card-title>
    <!---------------------------------------------------------------------------->

    <!----------------------EDIT, ADD NEW BRAND FORM------------------------------->

    <!---------BRANDS DATA TABLE------------------------------------------------->
    <v-data-table
      :headers="headers"
      :items="finalBrands"
      :search="search"
      class="elevation-1"
      v-if="!failed"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>BRANDS</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-btn color="success" outlined @click="addNewBrand" class="mx-2"
            ><v-icon> mdi-plus-circle-outline </v-icon> Add a brand</v-btn
          >
          <v-btn outlined color="secondary" v-on:click.native="openConf"
            ><v-icon> mdi-hammer-wrench </v-icon> Configuration</v-btn
          >

          <!---------DIALOG DELETE BRAND------------------------------------------------->
          <v-dialog v-model="dialogDelete" width="unset">
            <v-card>
              <v-card-title class="headline"
                >Are you sure you want to delete brand
                {{ selecetdBrand }}?</v-card-title
              >
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" outlined @click="closeDelete"
                  >Cancel</v-btn
                >
                <v-btn color="success" outlined @click="deleteItemConfirm"
                  >OK</v-btn
                >
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!----------------------------------------------------------------------------->
        </v-toolbar>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon small class="mr-2" @click="editBrand(item)">
          mdi-pencil
        </v-icon>
        <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
      </template>
    </v-data-table>
    <!---------------------------------------------------------------------------->

    <!---------------------------------------------------------------------------->

    <!----------------------RRP CONFIG FORM--------------------------------------->
    <v-form ref="RRPconfigForm" lazy-validation>
      <v-dialog v-model="dialogConfig" max-width="500px">
        <v-card>
          <v-card-title class="headline footer" primary-title>
            Edit currency values
          </v-card-title>
          <br />
          <v-card-text>
            <v-form @submit.prevent="saveConfig">
              <v-row>
                <v-col
                  cols="12"
                  sm="6"
                  md="12"
                  v-for="(item, i) in rrpFields"
                  :key="i"
                >
                  <div class="d-flex">
                    <div style="width: 100%">
                      <v-text-field
                        name="title"
                        label="Field title"
                        v-model="item.RRPname"
                        type="text"
                        required
                        :rules="[rules.required]"
                      >
                      </v-text-field>
                    </div>
                    <div style="width: 100%">
                      <v-checkbox
                        name="required"
                        label="Value is required"
                        v-model="item.required"
                      >
                      </v-checkbox>
                    </div>
                    <div class="d-flex align-center">
                      <v-icon
                        name="delete"
                        label="Delete"
                        v-model="item.fieldDelete"
                        medium
                        @click="handleSelectItem(item)"
                      >
                        mdi-delete
                      </v-icon>
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs"
                        v-on="on"
                        class="icon_style"
                        @click="addRRPFields()"
                      >
                        mdi-plus-circle-outline
                      </v-icon>
                    </template>
                    <span>Add RRP field</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" outlined @click="saveConfig">Save</v-btn>
            <v-btn color="error" outlined @click="dialogConfig = false"
              >Close</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-form>
    <!---------------------------------------------------------------------------->

    <!----------------------DELETE RRP DIALOG------------------------------------->
    <v-dialog v-model="dialogDeleteRRP" width="unset">
      <v-card>
        <v-card-title class="headline"
          >Are you sure you want to delete this RRP field?</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" outlined @click="closeDeleteRRP">Cancel</v-btn>
          <v-btn color="success" outlined @click="deleteRRP">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!---------------------------------------------------------------------------->

    <!----------------------RED SNACKBAR------------------------------------------>
    <v-snackbar
      top
      v-model="snackbar"
      color="#FF3232"
      class="white--text"
      width="800"
    >
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <!---------------------------------------------------------------------------->

    <!------STATUS COMPONENT IF SERVER IS COMPLETELY DOWN-------------------------->
    <status-info
      v-if="failed && filename !== ''"
      :responseMessage="responseMessage"
      :filename="filename"
      @close="closeStatuDialog"
    >
    </status-info>
    <!---------------------------------------------------------------------------->

    <!-----------------STATUS DIALOG, WHEN DOING STUFF WITH BRANDS---------------->
    <v-dialog persistent v-model="statusDialog" width="unset">
      <status-info
        :responseMessage="responseMessage"
        :filename="filename"
        :pending="pending"
        @close="closeStatuDialog"
      ></status-info>
    </v-dialog>
    <!---------------------------------------------------------------------------------->

    <BrandForm
      :brand="brand"
      v-if="showBrandForm"
      :formTitle="formTitle"
      @closeBrandForm="closeBrandForm"
    ></BrandForm>
  </v-container>
  <!------------------------------------------------------------------------------->
</template>

<script>
import axios from "axios";
import StatusInfo from "../organisms/StatusInfo";
import BrandForm from "../Brands/BrandForm.vue";

export default {
  name: "Brands",
  components: {
    StatusInfo,
    BrandForm,
  },
  data: () => ({
    valid: true,
    search: "",
    dialogDelete: false,
    dialogConfig: false,
    dialogDeleteRRP: false,
    snackbar: false,
    snackbarSuccess: false,
    selectedRRP: "",
    snackbarText: "",
    snackbarSuccessText: "",
    finalBrands: [],
    headers: [],
    rules: {
      required: (value) => !!value || "Field is required.",
    },
    brands: [],
    allCurrencyRates: [],
    tempCurrencyRates: [],
    allCurrencyRatesObj: "",
    firstRRPFields: [],
    rrpFields: [], // will be populated with real values for brands CONFIGURATION
    selecetdBrand: "",
    editedItem: {},
    responseMessage: "",
    filename: "",
    failed: false,
    createdCurrencyRates: [],
    statusDialog: false,
    pending: false,
    currencies: [],

    showBrandForm: false,
    brand: undefined,
    formTitle: "",
  }),
  created() {
    this.getData();
    this.getCurrencies();
  },
  watch: {
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
  computed: {},
  methods: {
    editBrand(item) {
      this.brand = item;
      this.formTitle = `Edit brand ${item.brandName}`;
      this.showBrandForm = true;
    },
    addNewBrand() {
      this.brand = {};
      this.formTitle = `Add brand`;
      this.showBrandForm = true;
    },
    closeBrandForm(changed) {
      this.showBrandForm = false;
      //if brands changed
      if (changed) {
        this.getData();
        this.getCurrencies();
      }
    },

    handleSelectItem(item) {
      this.dialogDeleteRRP = true;
      this.selectedRRP = item.RRPname;
    },

    async getData() {
      try {
        const response = await axios("api/currencyrates");

        if (response) {
          this.allCurrencyRatesObj = response.data.AllCurrencyRates;
          this.setCurrencyRates();
          this.setRRPConf();
          const response2 = await axios("api/brands");
          if (response2) {
            this.brands = response2.data;
            this.setData();
          }
        }
      } catch (error) {
        switch (error.response.status) {
          case 400:
            this.filename = "empty.svg";
            this.failed = true;
            this.responseMessage =
              "Sorry, something went wrong, please contact TECH team!";
            break;
          case 401:
            //clear local storage, push to login
            localStorage.clear();
            this.$router.push("login");
            break;
          case 403:
            this.filename = "403_forbidden.svg";
            this.failed = true;
            this.responseMessage =
              "Sorry, you are forbidden to do this action!";
            break;
          case 500:
            this.filename = "server_down.svg";
            this.failed = true;
            this.responseMessage =
              "Internal server error, please contact TECH team!";
        }
      }
    },
    setHeaders() {
      this.headers = [];
      this.headers.push(
        { text: "Title", value: "brandName" },
        { text: "Sub-brand", value: "subBrand" },
        { text: "Original currency", value: "originalCurrency" }
      );
      for (var i in this.allCurrencyRatesObj) {
        this.headers.push({
          text: this.allCurrencyRatesObj[i].RRPname,
          value: "RRPvalue" + this.allCurrencyRatesObj[i].RRPname,
        });
      }
    },
    setRRPConf() {
      this.rrpFields = [];
      for (var i in this.allCurrencyRatesObj) {
        var currencyRate = this.allCurrencyRatesObj[i];
        this.rrpFields.push({
          RRPname: currencyRate.RRPname,
          required: currencyRate.required,
        });
        // make a copy of fields:
        this.firstRRPFields.push({
          RRPname: currencyRate.RRPname,
          required: currencyRate.required,
        });
      }
    },
    setData() {
      this.setHeaders();
      var fin = [];

      for (var i in this.allCurrencyRatesObj) {
        for (var j in this.brands) {
          var value = this.searchRates(
            this.allCurrencyRatesObj[i].RRPname,
            this.brands[j].currencyRates
          );
          var brand = this.brands[j];
          var currencyItem = this.allCurrencyRatesObj[i];
          var RRPvalueName2 = "RRPvalue" + currencyItem.RRPname.toString();
          var RRPName2 = "RRPname" + currencyItem.RRPname.toString();
          var found = fin.find(
            (element) => element.brandName == brand.brandName
          );
          if (found != null) {
            const indx = fin.indexOf(found);
            found[RRPvalueName2] = value;
            found[RRPName2] = currencyItem.RRPname.toString();
            fin[indx] = found;
          } else {
            var id = brand.id;
            var brandName = brand.brandName;
            var subBrand = brand.subBrand;
            var originalCurrency = brand.originalCurrency;
            var rrpName = this.searchRRPnames(
              currencyItem.RRPname,
              brand.currencyRates
            ).RRPname;
            var tempObj = {
              id: id,
              brandName: brandName,
              subBrand: subBrand,
              originalCurrency: originalCurrency,
              [RRPName2]: rrpName,
              [RRPvalueName2]: value,
              currencyRates: brand.currencyRates,
            };
            if (brand.brandStories) {
              tempObj["brandStories"] = brand.brandStories;
            }
            fin.push(tempObj);
          }
        }
      }
      this.finalBrands = fin;
      this.headers.push({ text: "Actions", value: "actions", sortable: false });
    },
    setCurrencyRates() {
      //creating array of curr rates for adding new product
      this.tempCurrencyRates = this.allCurrencyRatesObj;
      for (var rate in this.tempCurrencyRates) {
        var item = this.tempCurrencyRates[rate];
        const indx = this.tempCurrencyRates.indexOf(item);
        item["value"] = "";
        this.tempCurrencyRates[indx] = item;
      }
    },
    searchRates(nameKey, currencyRates) {
      for (var j in currencyRates) {
        if (currencyRates[j].RRPname === nameKey) {
          return currencyRates[j].value;
        }
      }
      return "";
    },
    searchRRPnames(nameKey, rrpobjects) {
      for (var j in rrpobjects) {
        if (rrpobjects[j].RRPname === nameKey) {
          return rrpobjects[j];
        }
      }
      return "";
    },

    async openConf() {
      this.dialogConfig = true;
    },
    saveConfig() {
      // validation
      if (this.$refs.RRPconfigForm.validate()) {
        // check if all fields are filled
        const validation = this.rrpFields.every((item) => item.RRPname);

        // check if any fields are empty
        if (!validation) {
          this.snackbarText = "There are empty fields!";
          this.snackbar = true;
        } else {
          var rrpValuesArr = this.rrpFields.map(function (item) {
            return item.RRPname;
          });
          var isDuplicate = rrpValuesArr.some(function (item, idx) {
            return rrpValuesArr.indexOf(item) != idx;
          });
          //check if there are no duplicates of RRP names
          if (!isDuplicate) {
            //check if new array is the same as the array showed at the start
            if (!this.checkArrays(this.firstRRPFields, this.rrpFields)) {
              this.pending = true;
              this.statusDialog = true;
              this.dialogConfig = false;

              this.putCurrencyRates();
            } else {
              this.dialogConfig = false;
            }
          } else {
            this.snackbarText = "There are duplicate RRP fields!";
            this.snackbar = true;
          }
        }
      }
    },
    putCurrencyRates() {
      //post to server
      axios
        .put("api/currencyrates", this.rrpFields)
        .then(() => {
          this.filename = "high_five.svg";
          this.pending = false;
          this.responseMessage = "Success! Currency rates updated!";
        })
        .catch((error) => {
          switch (error.response.status) {
            case 400:
              this.filename = "empty.svg";
              this.pending = false;
              this.responseMessage =
                "Sorry, something went wrong, please contact TECH team!";
              break;
            case 401:
              //clear local storage, push to login
              localStorage.clear();
              this.$router.push("login");
              break;
            case 403:
              this.filename = "403_forbidden.svg";
              this.pending = false;
              this.responseMessage =
                "Sorry, you are forbidden to do this action!";
              break;
            case 500:
              this.filename = "server_down.svg";
              this.pending = false;
              this.responseMessage =
                "Internal server error, please contact TECH team!";
          }
        });
    },
    //CHECK IF ARRAYS ARE EQUAL
    checkArrays(array1, array2) {
      const arraysEqual = (a1, a2) =>
        a1.length === a2.length &&
        a1.every((o, idx) => objectsEqual(o, a2[idx]));

      const objectsEqual = (o1, o2) =>
        typeof o1 === "object" && Object.keys(o1).length > 0
          ? Object.keys(o1).length === Object.keys(o2).length &&
            Object.keys(o1).every((p) => objectsEqual(o1[p], o2[p]))
          : o1 === o2;
      return arraysEqual(array1, array2);
    },

    addRRPFields() {
      this.rrpFields.push({
        RRPname: "",
        required: true,
      });
    },
    removeRRPFields() {
      this.dialogDeleteRRP = true;
    },
    deleteRRP() {
      this.rrpFields.splice(
        this.rrpFields.findIndex((e) => e.RRPname === this.selectedRRP),
        1
      );
      this.dialogDeleteRRP = false;
    },

    deleteItem(item) {
      this.editedIndex = this.finalBrands.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
      this.selecetdBrand = item.brandName;
    },

    deleteItemConfirm() {
      this.pending = true;
      this.statusDialog = true;
      this.dialogDelete = false;
      //deleting brand
      let brandName = this.editedItem.brandName;
      axios
        .delete("api/brand/" + this.editedItem.id)
        .then(() => {
          this.filename = "high_five.svg";
          this.pending = false;
          this.dialogDelete = false;
          this.responseMessage = "Success! Brand " + brandName + " deleted!";
        })
        .catch((error) => {
          switch (error.response.status) {
            case 400:
              this.filename = "empty.svg";
              this.pending = false;
              this.responseMessage =
                "Sorry, something went wrong, please contact TECH team!";
              break;
            case 401:
              //clear local storage, push to login
              localStorage.clear();
              this.$router.push("login");
              break;
            case 403:
              this.filename = "403_forbidden.svg";
              this.pending = false;
              this.responseMessage =
                "Sorry, you are forbidden to do this action!";
              break;
            case 500:
              this.filename = "server_down.svg";
              this.pending = false;
              this.responseMessage =
                "Internal server error, please contact TECH team!";
          }
        });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.brandStories = [""];
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    closeDeleteRRP() {
      this.dialogDeleteRRP = false;
    },
    getCurrencies() {
      //getting dropdown selections from server
      axios
        .get("api/products/categories?categories=currency")
        .then((response) => {
          this.currencies = response.data.currency;
        })
        .catch((e) => console.log(e));
    },
    closeStatuDialog() {
      this.getData();
      this.statusDialog = false;
    },
  },
};
</script>
